.root {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px clamp(16px, 4vw, 48px);
  border-bottom: 1px solid var(--color-border);
  background: var(--color-surface);
}

.avatar {
  width: 32px;
  height: 32px;
  border-radius: var(--radius-sm);
  object-fit: contain;
  border: 1px solid var(--color-border);
}

.copy {
  display: flex;
  flex-direction: column;
  line-height: 1.25;
}

.name {
  font-size: 14px;
  font-weight: 700;
  color: var(--color-brand-primary);
}

.role {
  font-size: 12px;
  color: var(--color-text-secondary);
}
